import AiChatPage from "./pages/AiChatPage.vue";

export default {
	AiChatPage,
};
